module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "no_club"
  }, [_c('div', {
    staticStyle: {
      "height": "3.56rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "create_btn",
    on: {
      "click": _vm.toClub
    }
  }, [_vm._v("立即创建")])]), _vm._v(" "), _c('div', {
    staticClass: "no_grade",
    staticStyle: {
      "margin-top": "0.3rem"
    }
  }, [_c('div', {
    staticStyle: {
      "height": "3.56rem"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "create_btn",
    on: {
      "click": _vm.toKaoji
    }
  }, [_vm._v("立即创建")])])]), _vm._v(" "), _c('van-dialog', {
    staticClass: "dialog-box",
    attrs: {
      "title": "",
      "showConfirmButton": false
    },
    model: {
      value: (_vm.clubShow),
      callback: function($$v) {
        _vm.clubShow = $$v
      },
      expression: "clubShow"
    }
  }, [_c('div', {
    staticClass: "dialog-head"
  }, [_vm._v("创建须知")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-content"
  }, [_c('div', {
    staticClass: "dialog-step-li"
  }, [_vm._v("\n        附件下载\n        "), _vm._v(" "), _c('div', [_c('van-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.download(
          '啦啦操星级俱乐部管理办法',
          'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1623833117774-11.pdf'
        )
      }
    }
  }, [_vm._v("\n            啦啦操星级俱乐部管理办法\n          ")])], 1)]), _vm._v(" "), _c('van-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        return _vm.toClubNext(0)
      }
    }
  }, [_c('div', [_vm._v("我已阅读并同意遵守本须知声明的所有条款")]), _vm._v(" "), _c('div', [_vm._v("点击进行创建")])]), _vm._v(" "), _c('van-button', {
    attrs: {
      "type": "default",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.clubShow = false
      }
    }
  }, [_vm._v("我再想想")])], 1)]), _vm._v(" "), _c('van-dialog', {
    staticClass: "dialog-box",
    attrs: {
      "title": "",
      "showConfirmButton": false
    },
    model: {
      value: (_vm.kaojiShow),
      callback: function($$v) {
        _vm.kaojiShow = $$v
      },
      expression: "kaojiShow"
    }
  }, [_c('div', {
    staticClass: "dialog-head"
  }, [_vm._v("创建须知")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-content"
  }, [_c('div', {
    staticClass: "dialog-step-li"
  }, [_vm._v("1.可创建类型为：")]), _vm._v(" "), _c('ul', [_c('li', {
    staticClass: "dialog-li"
  }, [_c('div', {
    staticClass: "li-left"
  }, [_vm._v("（1）七彩星级指定考级点")]), _vm._v(" "), _c('div', {
    staticClass: "li-right"
  }, [_vm._v("0元")])]), _vm._v(" "), _c('li', {
    staticClass: "dialog-li"
  }, [_c('div', {
    staticClass: "li-left"
  }, [_vm._v("（2）七彩星级指定样板考级点")]), _vm._v(" "), _c('div', {
    staticClass: "li-right"
  }, [_vm._v("9800元")])]), _vm._v(" "), _c('li', {
    staticClass: "dialog-li"
  }, [_c('div', {
    staticClass: "li-left"
  }, [_vm._v("（3）七彩星级指定考级中心")]), _vm._v(" "), _c('div', {
    staticClass: "li-right"
  }, [_vm._v("120000元")])]), _vm._v(" "), _c('li', {
    staticClass: "dialog-li"
  }, [_c('div', {
    staticClass: "li-left"
  }, [_vm._v("（4）七彩星级指定样板考级中心")]), _vm._v(" "), _c('div', {
    staticClass: "li-right"
  }, [_vm._v("135000元")])])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-step-li"
  }, [_vm._v("\n        2.请确认您已准备好营业执照扫描件（.jpg或.png）/根据我们APP可以接收的图片格式进行设定/\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-step-li"
  }, [_vm._v("\n        3.附件下载\n        "), _c('div', {
    staticClass: "dialog-step-li-text",
    on: {
      "click": function($event) {
        return _vm.download(
          '啦啦操七彩星级管理办法',
          'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1622687436968-14.pdf'
        )
      }
    }
  }, [_vm._v("\n          啦啦操七彩星级管理办法\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "dialog-step-li-text",
    on: {
      "click": function($event) {
        return _vm.download(
          '七彩星级考级中心（点）加盟方案',
          'https://ccago.oss-cn-hangzhou.aliyuncs.com/uploader/000/user-xxx/vc-upload-1622687436968-12.pdf'
        )
      }
    }
  }, [_vm._v("\n          七彩星级考级中心（点）加盟方案\n        ")])]), _vm._v(" "), _c('van-button', {
    attrs: {
      "type": "primary",
      "size": "large"
    },
    on: {
      "click": function($event) {
        return _vm.toKaojiNext(0)
      }
    }
  }, [_c('div', [_vm._v("我已阅读并同意遵守本须知声明的所有条款")]), _vm._v(" "), _c('div', [_vm._v("点击进行创建")])]), _vm._v(" "), _c('van-button', {
    attrs: {
      "type": "default",
      "size": "large"
    },
    on: {
      "click": function($event) {
        _vm.kaojiShow = false
      }
    }
  }, [_vm._v("我再想想")])], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b7589932","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/user/mine/club/NoMyClub.vue
// module id = 2581
// module chunks = 0